<template>
  <div>
    <BatteryCopy></BatteryCopy>
  </div>
</template>

<script>
import BatteryCopy from "@/components/BatteryCopy/index.vue";
export default {
  components: {
    BatteryCopy,
  },
};
</script>

<style></style>
